import { render, staticRenderFns } from "./RelatorioLista.vue?vue&type=template&id=ada453c6&scoped=true&lang=html"
import script from "./RelatorioLista.vue?vue&type=script&lang=js"
export * from "./RelatorioLista.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLista.vue?vue&type=style&index=0&id=ada453c6&prod&scoped=true&lang=css"
import style1 from "./RelatorioLista.vue?vue&type=style&index=1&id=ada453c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada453c6",
  null
  
)

export default component.exports